import { Box } from "@chakra-ui/react";
import AddPost from "../Components/AddPost";

export default function EditPost(){
    return(
        <Box>
            <AddPost />
        </Box>
    )
}